<template>
    <a-modal v-model:open="open" class="modals">
        <div style="display: flex;flex-direction: column;align-items: center;">
            <span style="font-size: 26px;font-weight: bold;">{{ announces.title }}</span>
            <span  style="font-size: 18;color: #7f8c8d;text-align: center;">{{ announces.createdAt }}</span>      

            <a-divider style="margin: auto;">{{ announces.publisherName }}</a-divider>

            <span  style="font-size: 20;margin-top: 20px;text-align: center;font-family: '宋体';">{{ announces.content }}</span>
        </div>


            <a v-if="announces.attachmentUrl !==null " @click="down" href="#">点击下载附件</a>
        <template #footer>
            <a-button key="back" type="primary" @click="toAddCancel">返回</a-button>
        </template>
    </a-modal>
</template>
<script>
import { announce,downAnnFile } from '@/api/service';
import { ref, watch } from 'vue';
export default {
    name: 'readAnnounce',
    setup() {
        const id = ref(null);//添加提交时的加载
        const open = ref(false);//是否打开
        const announces = ref({});//详细信息

        watch(open, (newVal) => {
            if (newVal === true) {
                announceInfo();
            }
        });
        
        //下载附件
        const down = async () => {
            console.log(announces.value.attachmentUrl);
            await downAnnFile({'path':announces.value.attachmentUrl});
        }

        //查询详细信息
        const announceInfo = async () => {
            if (!id.value) {
                return;
            }
            const response = await announce(id.value);
            if (response.code === 200) {
                announces.value = response.data;
            }
        }

        //关闭窗口
        const toAddCancel = () => {
            open.value = false;
        }

        return {
            open,
            down,
            id,
            announces,
            announceInfo,
            toAddCancel,
            ref
        };
    }
}
</script>
<style>
.push-input {
    margin-top: 20px;
    display: block;
}

.push-file {
    margin-top: 20px;
    display: inline-flex;
}

.modals {
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    width: 500px;
}

.push-data {
    width: 80%;
}

.avatar-uploader>.ant-upload {
    width: 128px;
    height: 128px;
}

.avatar-uploader>.ant-upload {
    width: 128px;
    height: 128px;
}

.leftLb {
    margin-left: 4.5%;
}
</style>